<template>
    <div class="info-event-item grid">
        <script type="application/ld+json"
                v-for="(event, eventIdx) in course.info_events" :key="eventIdx"
                v-text="JSON.stringify(event.content.schema)">
        </script>

        <!-- <pre v-if="course" v-text="course"></pre> -->

        <div class="info-event-item--row grid--row">
            <div class="info-event-item--col grid--col">
                <h2 class="u-reset info-event-item--title" v-html="course.name"></h2>
            </div>
            <div class="info-event-item--col grid--col">
                <span v-if="!numInfoEvents" class="info-event-item--empty" v-text="generalLabels.noEvents"></span>

                <cmp-rich-button class="info-event-item--top-button"
                        v-if="numInfoEvents"
                        v-for="(event, eventIdx) in infoEventsTop" :key="eventIdx"
                        button-facet="light" :theme="course.color" :plugin="event">
                </cmp-rich-button>

                <cmp-accordion v-if="numInfoEvents > 1"
                        facet="info-event"
                        :is-active="accordionState"
                        :passive-mode="true"
                        @request-change="updateState($event)">
                    <!-- head -->
                    <template slot="head" slot-scope="props">
                        <div class="info-event-item--accordion-head"
                                :class="accordionHeadClasses(props.isActive)"
                                v-if="!isHighlighted">
                            <span class="info-event-item--accordion-head-title">
                                <span v-if="props.isActive" v-text="generalLabels.collapse"></span>
                                <span v-else v-text="generalLabels.expand"></span>
                            </span>

                            <cmp-icon class="info-event-item--accordion-head-icon"
                                    symbol="chevron_down"
                                    size="x-small">
                            </cmp-icon>
                        </div>
                    </template>

                    <!-- body -->
                    <template slot="body" slot-scope="props">
                        <div class="info-event-item--accordion-body">
                            <cmp-rich-button class="info-event-item--button"
                                    v-for="(event, eventIdx) in infoEventsInAccordion" :key="eventIdx"
                                    :theme="course.color" :plugin="event">
                            </cmp-rich-button>
                        </div>
                    </template>
                </cmp-accordion>
            </div>
            <div class="info-event-item--col info-event-item--col__more-info grid--col">
                <cmp-rich-button class="info-event-item--button"
                        :theme="course.color" :plugin="course.course_button">
                </cmp-rich-button>
            </div>
        </div>
    </div>
</template>

<script>
    import bemMixin from 'vue/mixins/bem';


    export default {
        mixins: [
            bemMixin('info-event-item'),
        ],
        props: {
            course: Object,
            generalLabels: Object,
            isHighlighted: Boolean,
        },
        data() {
            return {
                state: {
                    accordion: false,
                },
            };
        },
        computed: {
            numInfoEvents() {
                return Array.isArray(this.course.info_events) ? this.course.info_events.length : 0;
            },
            infoEventsTop() {
                return this.course.info_events.filter((item, idx) => idx === 0);
            },
            infoEventsInAccordion() {
                return this.course.info_events.filter((item, idx) => idx !== 0);
            },
            accordionState() {
                return this.isHighlighted || this.state.accordion;
            },
        },
        methods: {
            accordionHeadClasses(isActive) {
                return [
                    this.bemAdd(isActive ? 'is-active' : '', 'accordion-head'),
                ];
            },
            compileButtonData(event) {
                return {
                    content: {
                        icon: 'info',
                        label: event.date,
                    },
                };
            },
            updateState(updateVal) {
                this.state.accordion = updateVal;
            },
        },
    };
</script>



// WEBPACK FOOTER //
// index.vue?fabfcc32